import { ForgotPassword } from '@/components/Form/Auth/Authform.type';

import { API_ROUTES } from '../apiRoutes';
import { axiosPost } from '../axiosService';

export const passwordReset = async (payload: ForgotPassword): Promise<any> => {
  return axiosPost<ForgotPassword>({
    url: API_ROUTES.passwordResetUrl(),
    payload,
    isPublic: true,
  });
};
